import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useProductListingData from 'hooks/useProductListingData';
import useCurrentShowroom from 'hooks/useCurrentShowroom';
import ProductListingPageContext from 'data-hooks/context/ProductListingPageContext';
import { GET_RETAIL_STORE_PRODUCTS_DATA } from 'mocks/queries';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import CustomProductListUI from 'components/consumer/CustomProductList/CustomProductListUI';

const DynamicShowroomProductList = ({ config, isAdmin = false }) => {
  const hasLoadingAllDataStartedRef = useRef(false);

  const {
    listStyle = 'slider',
    listCardSize: { cardSizeSelected = 'medium' } = {},
  } = config || {};

  const {
    showroom,
    loading: showroomLoading,
    error: showroomError,
  } = useCurrentShowroom();

  const storeId = showroom?.id;

  const dataWithState = useProductListingData(
    GET_RETAIL_STORE_PRODUCTS_DATA,
    {
      variables: { storeId },
      skip: !storeId || isAdmin,
    },
    { isScrollTrackingDisabled: true }
  );

  const { loading, loadAllProducts } = dataWithState;

  useEffect(() => {
    if (!loading && !hasLoadingAllDataStartedRef.current && loadAllProducts) {
      hasLoadingAllDataStartedRef.current = true;
      window.requestIdleCallback(async () => {
        loadAllProducts();
      });
    }
  }, [loading, loadAllProducts]);

  if (isAdmin) {
    return (
      <AdminPlaceholder className="!min-h-[470px]">
        Dynamic Showroom Product List
      </AdminPlaceholder>
    );
  }

  if (showroomLoading || loading) {
    return (
      <div className="w-full py-12 text-center">
        <div className="text-gray-600">Loading showroom products...</div>
      </div>
    );
  }

  if (showroomError || !showroom) {
    return null;
  }

  return (
    <ProductListingPageContext.Provider value={dataWithState}>
      <CustomProductListUI listStyle={listStyle} cardSize={cardSizeSelected} />
    </ProductListingPageContext.Provider>
  );
};

DynamicShowroomProductList.propTypes = {
  config: PropTypes.object,
  isAdmin: PropTypes.bool,
};

export default DynamicShowroomProductList;
